import agendaMailSubCategory from './agendaMailSubCategory';
import customizeActionsSubCategory from './customizeActionsSubCategory';
import eventsAndInvitationsSubCategory from './eventsAndInvitationsSubCategory';
import eventsFromEmailSubCategory from './eventsFromEmailSubCategory';
import pbpSubCategory from './pbpSubCategory';
import sharedCalendarsSubCategory from './sharedCalendarsSubCategory';
import viewSubCategory from './viewSubCategory';
import intelligenceSubCategory from './intelligenceSubCategory';
import weatherSubCategory from './weatherSubCategory';
import { ControlIcons } from 'owa-control-icons';
import { OptionCategory } from 'owa-options-core';

let calendarCategory: OptionCategory = {
    key: 'calendar',
    titleStringKey: 'optionCategory_Calendar',
    icon: ControlIcons.Calendar,
    subcategories: [
        viewSubCategory,
        eventsAndInvitationsSubCategory,
        weatherSubCategory,
        eventsFromEmailSubCategory,
        agendaMailSubCategory,
        sharedCalendarsSubCategory,
        customizeActionsSubCategory,
        intelligenceSubCategory,
        pbpSubCategory,
    ],
};

export default calendarCategory;
